/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_LabelInputs */

const en_why_listening_newsletter_label = /** @type {(inputs: Why_Listening_Newsletter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter inbox`)
};

const es_why_listening_newsletter_label = /** @type {(inputs: Why_Listening_Newsletter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeja de newsletters`)
};

/**
* | output |
* | --- |
* | "Newsletter inbox" |
*
* @param {Why_Listening_Newsletter_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_label = /** @type {((inputs?: Why_Listening_Newsletter_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_label(inputs)
	return en_why_listening_newsletter_label(inputs)
});